import { useFetchTrackingInfo } from '@/hooks';
import { Flex, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SectionLoader } from './Loader';

export const ShipmentStep = ({ trackingNumber }: { trackingNumber: string }): JSX.Element => {
  const { t } = useTranslation();

  const { hasError, isLoading, trackingInfo } = useFetchTrackingInfo(trackingNumber);

  const { courierName, histories } = trackingInfo ?? {};

  const getDate = (date: string): string => {
    return new Date(date).toLocaleDateString().replaceAll('/', '.');
  };

  const getHours = (date: string): string => {
    return `${new Date(date).getHours()}:${new Date(date).getMinutes()}`;
  };

  if (hasError)
    return (
      <Flex
        alignItems="flex-start"
        direction="column"
        gap={8}
        h="200px"
        justifyContent="center"
        w="100%"
      >
        <Text fontSize={{ base: 'h3.base', md: 'h3.md' }}>
          {t('SHIPMENT_DETAILS.TRACKING_TITLE')}
        </Text>
        <Text>{t('SHIPMENT_DETAILS.NO_INFORMATION_AVAILABLE')}</Text>
      </Flex>
    );

  if (isLoading) return <SectionLoader />;

  return (
    <Flex
      alignItems="flex-start"
      direction="column"
      gap={8}
      justifyContent="flex-start"
      mb={14}
      mt={{ base: 0, md: 8 }}
      w="100%"
    >
      <Text fontSize={{ base: 'h3.base', md: 'h3.md' }}>
        {t('SHIPMENT_DETAILS.TRACKING_TITLE')}
      </Text>
      <Text fontSize={22} fontWeight="bold">
        {t('SHIPMENT_DETAILS.COURIER')} {courierName}
      </Text>
      <UnorderedList fontSize={18} listStyleType="none" ml={0} spacing={4}>
        {histories?.map((his, i) => (
          <ListItem
            _after={
              i !== 0
                ? {
                    backgroundColor: 'red',
                    content: '""',
                    h: '35px',
                    left: '-32px',
                    position: 'absolute',
                    top: '-34px',
                    w: '3px',
                  }
                : {}
            }
            _before={{
              border: '4px',
              borderRadius: '50%',
              color: 'red',
              content: '""',
              left: '-45px',
              position: 'absolute',
              h: '30px',
              top: '-2px',
              w: '30px',
            }}
            key={his.date}
            mb={8}
            ml={12}
            position="relative"
          >
            <Flex alignItems="flex-start">
              <Flex direction={{ base: 'column', md: 'row' }}>
                <Flex direction="row">
                  <Text fontWeight="bold" mr={6} w="100px">
                    {getDate(his.date)}
                  </Text>
                  <Text w="100px">{getHours(his.date)}</Text>
                </Flex>
                <Text fontSize={{ base: '16', md: '18' }}>{his.courierStatusDescription}</Text>
              </Flex>
            </Flex>
          </ListItem>
        ))}
      </UnorderedList>
    </Flex>
  );
};
